import { ICotizacionData } from "./journey.model";

export const journeyDataDefault: ICotizacionData = {

  idKeycloak: "",
  id: "",
  idLeaseTech: 0,
  clientInfoId: 0,
  idDavinci: '',
  rfc: "",
  quoterId: '',
  carId: "",
  priceWithIva: 0,
  depositIncome: 0,
  product: {
    concept: '',
    period: ''
  },
  quoteId: '',
  E3: {
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  opportunityId: 2217,
  client: {
    lastNamePF: "",
    phoneNumber: "",
    address: {
      numInt: "",
      numExt: "",
      stateId: "",
      calle: "",
      municipality: "",
      cityId: "",
      cp: "",
      countryId: "",
      colonia: ""
    },
    firstNamePF: "",
    birthDate: "",
    email: "",
    rfc: "",
    curp: "",
  },
  step: "",
  sfAccountId: '',
  status: "",
  flowType: 'A',
  E4: {
    data: {
      sendMethod: "NONE"
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E5: {
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E6: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E7: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      query_executed: false,
      notification_date: 0,
      client_id_davinci: 0
    },
    dateEnd: ""
  },
  E8: {
    data: {
      addressAntiquity: 0,
      domicileSeniorityCatalogId: 0,
      clientInfoId: 0,
      jobSeniorityMonths: 0,
      domicileSeniorityYears: 0,
      genderGenericId: 0,
      jobSeniorityYears: 0,
      tipOpporClientInfoId: 0,
      opportunityId: 0,
      domicileSeniorityMonths: 0,
      employmentAntiquity: 0,
      maritalStatusGenericId: 0,
      jobSeniorityCatalogId: 0,
      housingSituation: 0,
      verifiableIncome: '',
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E9: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      rate: "",
      client_id_davinci: 0,
      execution_status: false,
      jointly_bound: "NO",
      visit: "No",
      client_type: " : ",
      pd_model: "",
      deposit_income: "",
      errors: null,
      max_payment_capacity: ""
    },
    dateEnd: ""
  },
  E10: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  sfAccountIdEndorsment: '',
  clientEndorsment: {
    lastNamePF: "",
    phoneNumber: "",
    birthDate: '',
    address: {
      numInt: "",
      numExt: "",
      stateId: "",
      calle: "",
      municipality: "",
      cityId: "",
      cp: "",
      countryId: "",
      colonia: ""
    },
    firstNamePF: "",
    email: "",
    rfc: "",
    curp: ""
  },
  rfcEndorsment: "",
  clientInfoIdEndorsment: 0,
  opportunityEndorsment: {
    opportunityId: 0,
    isActive: 0
  },
  opportunityIdEndorsment: 0,
  E11: {
    data: {
      sendMethod: "NONE"
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "2022-03-18T21:43:37.403Z",
    nombre: "",
    status: ""
  },
  E13: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E12: {
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E14: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      query_executed: false,
      notification_date: 0,
      client_id_davinci: 2218
    },
    dateEnd: ""
  },
  E15: {
    data: {
      addressAntiquity: 138,
      domicileSeniorityCatalogId: 136,
      clientInfoId: 1262,
      jobSeniorityMonths: 2,
      domicileSeniorityYears: 2,
      genderGenericId: 131,
      jobSeniorityYears: 2,
      tipOpporClientInfoId: 112,
      opportunityId: 2218,
      domicileSeniorityMonths: 2,
      employmentAntiquity: 143,
      maritalStatusGenericId: 11,
      jobSeniorityCatalogId: 140,
      housingSituation: 144,
      verifiableIncome: ''
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E16: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      rate: "",
      client_id_davinci: 0,
      execution_status: false,
      jointly_bound: "NO",
      visit: "No",
      client_type: " : ",
      pd_model: "",
      deposit_income: "",
      errors: null,
      max_payment_capacity: ""
    },
    dateEnd: ""
  },
  E17: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E18: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E19: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E20: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E21: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E22: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E23: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E24: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: "",
    priceChanged: false
  },
  E25: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: "",
    downloadedPDFAdvPay: false
  },
  E26: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E27: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: "",
    downloadedPDFInitPay: false
  },
  E28: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: "",
    data: {
      deliveryDate: {
        estimatedDate: '',
        confirmedDate: ''
      },
      fulfillment: []
    }
  },
  acceptShippingCost: false,
  E32: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E33: {
    data: {
      sendMethod: "NONE"
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "2022-03-18T21:43:37.403Z",
    nombre: "",
    status: ""
  },
  E34: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E35: {
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E36: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      query_executed: false,
      notification_date: 0,
      client_id_davinci: 2218
    },
    dateEnd: ""
  },
  E37: {
    data: {
      addressAntiquity: 138,
      domicileSeniorityCatalogId: 136,
      clientInfoId: 1262,
      jobSeniorityMonths: 2,
      domicileSeniorityYears: 2,
      genderGenericId: 131,
      jobSeniorityYears: 2,
      tipOpporClientInfoId: 112,
      opportunityId: 2218,
      domicileSeniorityMonths: 2,
      employmentAntiquity: 143,
      maritalStatusGenericId: 11,
      jobSeniorityCatalogId: 140,
      housingSituation: 144,
      verifiableIncome: ''
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E38: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      rate: "",
      client_id_davinci: 0,
      execution_status: false,
      jointly_bound: "NO",
      visit: "No",
      client_type: " : ",
      pd_model: "",
      deposit_income: "",
      errors: null,
      max_payment_capacity: ""
    },
    dateEnd: ""
  },
  E40: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E41: {
    data: {
      sendMethod: "NONE"
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "2022-03-18T21:43:37.403Z",
    nombre: "",
    status: ""
  },
  E42: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    dateEnd: ""
  },
  E43: {
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E44: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      query_executed: false,
      notification_date: 0,
      client_id_davinci: 2218
    },
    dateEnd: ""
  },
  E45: {
    data: {
      addressAntiquity: 138,
      domicileSeniorityCatalogId: 136,
      clientInfoId: 1262,
      jobSeniorityMonths: 2,
      domicileSeniorityYears: 2,
      genderGenericId: 131,
      jobSeniorityYears: 2,
      tipOpporClientInfoId: 112,
      opportunityId: 2218,
      domicileSeniorityMonths: 2,
      employmentAntiquity: 143,
      maritalStatusGenericId: 11,
      jobSeniorityCatalogId: 140,
      housingSituation: 144,
      verifiableIncome: ''
    },
    dateStart: "",
    dateUpdate: "",
    dateEnd: "",
    nombre: "",
    status: ""
  },
  E46: {
    dateStart: "",
    dateUpdate: "",
    nombre: "",
    status: "",
    data: {
      rate: "",
      client_id_davinci: 0,
      execution_status: false,
      jointly_bound: "NO",
      visit: "No",
      client_type: " : ",
      pd_model: "",
      deposit_income: "",
      errors: null,
      max_payment_capacity: ""
    },
    dateEnd: ""
  },
}

